import { DrawerHeading, DrawerListSubHeader } from "../Drawer.styled";
import {
  MENU_COLLECTION_REQUIRED,
  PAGE_COLLECTION_REQUIRED,
} from "../../../constants/access";

import { DRAWER_MENU } from "../../../constants/menu";
import { Divider } from "@mui/material";
import { DrawerSectionProps } from "../../../types/DrawerSection";
import EnsureUserHasAccess from "../../../security/EnsureUserHasAccess";
import MenuItem from "../../Menu/MenuItem";
import { useTranslation } from "react-i18next";

const Tools = ({ open }: DrawerSectionProps) => {
  const { t } = useTranslation(["tools"]);

  return (
    <EnsureUserHasAccess
      collections={MENU_COLLECTION_REQUIRED.TOOLS}
      collectionStrategy="any"
      redirect={false}
    >
      <DrawerHeading sx={{ ...(open && { p: 0 }) }}>
        {open ? (
          <DrawerListSubHeader>{t("tools:tools_label")}</DrawerListSubHeader>
        ) : null}

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.TOOLS_CONFIG}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.TOOLS_CONFIG} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.TOOLS_MODELS}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.TOOLS_MODELS} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.PARCEL_EXTREMITY_GROUP}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.PARCEL_EXTREMITY_GROUP} />
        </EnsureUserHasAccess>
      </DrawerHeading>
      {!open ? <Divider /> : null}
    </EnsureUserHasAccess>
  );
};

export default Tools;
